/* eslint-disable import/no-anonymous-default-export */
import { api, asResult } from "utils/apiClient";
import { GroupType, UserType } from "utils/constants";
import { normalizeGroup, normalizeUser } from "utils/normalize";

export default {
  // Every location the caller may see; a location user gets their own.
  async listLocation() {
    const { items } = await api("GET", "/groups", {
      query: { type: GroupType.Location },
    });
    return { items: items.map(normalizeGroup) };
  },

  async listLocationUsers() {
    const { items } = await api("GET", "/users", {
      query: { type: UserType.Location },
    });
    return { items: items.map(normalizeUser) };
  },

  // The tenant is the only upper level sent; the BE reads the SP from it.
  async createLocation({ locationId, locationName, tenantId, mfa }) {
    return asResult(
      api("POST", "/groups", {
        body: {
          type: GroupType.Location,
          groupName: locationId,
          descName: locationName,
          tenantID: tenantId,
          mfa,
        },
      })
    );
  },

  async editLocation({ locationId, locationName, mfa }) {
    return asResult(
      api("PATCH", `/groups/${encodeURIComponent(locationId)}`, {
        body: { descName: locationName, mfa },
      })
    );
  },

  // The location is the only level sent: tenant, SP and mfa follow from it.
  async createLocationUser({ email, profileName, role, location }) {
    return asResult(
      api("POST", "/users", {
        body: {
          type: UserType.Location,
          username: email,
          email,
          profileName,
          role,
          locationID: location,
        },
      })
    );
  },
};
